module.exports = __webpack_public_path__ + "img/selected7-min.c22073cb.png";